import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

const EditPhoneItemComponent = ({ editIndex, cancel, save }) => {
  const dispatch = useDispatch()
  const formData = useSelector((state) => state.formData)
  const appData = useSelector((state) => state.appData)
  const layout = useSelector((state) => state.layout)
  
  const { phoneItems, family } = formData
  const item = phoneItems[editIndex]
  
  const [edits, setEdits] = useState({})

  return (
    <div>
      <h3>Rediger bruker</h3>
      <div>
        <div className="input_wrapper">
          <label htmlFor="firstName">Fornavn:</label>
          <input
            type="text"
            id="firstName"
            disabled
            defaultValue={edits.firstName || item.firstName}
            // value={edits.firstName || item.firstName}
            // onChange={ev => setEdits({ ...edits, firstName: ev.target.value })}
          />
        </div>
        <div className="input_wrapper">
          <label htmlFor="lastName">Etternavn:</label>
          <input
            type="text"
            id="lastName"
            disabled
            defaultValue={edits.lastName || item.lastName}
            // value={edits.lastName || item.lastName}
            // onChange={ev => setEdits({ ...edits, lastName: ev.target.value })}
          />
        </div>
        <div className="input_wrapper">
          <label htmlFor="phone">Telefonnr:</label>
          <input
            type="text"
            id="phone"
            value={edits.phone || item.phone}
            onChange={(ev) =>
              setEdits({ ...edits, phone: ev.target.value })
            }
          />
        </div>
        <div className="input_wrapper">
          <label htmlFor="email">E-post:</label>
          <input
            type="text"
            id="email"
            value={edits.email || item.email}
            onChange={(ev) =>
              setEdits({ ...edits, email: ev.target.value })
            }
          />
        </div>
      </div>
      <div className="buttons">
        <button className="cancel" onClick={cancel}>
          Avbryt
        </button>
        <button className="continue" onClick={() => save(edits)}>
          Lagre
        </button>
      </div>
    </div>
  )
}

export default EditPhoneItemComponent
